import { WritableStore } from "./WritableStore";
export class FormMember {
    constructor(eventsChannel, instance, userId, isOwner, isSigned, signDate, buddyId) {
        this.eventsChannel = eventsChannel;
        this.instance = instance;
        this.userId = userId;
        this.signDate = signDate;
        this.buddyId = buddyId;
        this._isOwner = new WritableStore(false);
        this._isSigned = new WritableStore(false);
        this.isOwnerReadable = this._isOwner.getReadable();
        this.isSignedReadable = this._isSigned.getReadable();
        this._isOwner.set(isOwner);
        this._isSigned.set(isSigned);
        eventsChannel.on('signed', event => this.onSigned(event));
        eventsChannel.on('unsigned', event => this.onUnsigned(event));
    }
    get isOwner() {
        return this._isOwner.value;
    }
    get isSigned() {
        return this._isSigned.value;
    }
    set isOwner(value) {
        this._isOwner.set(value);
    }
    set isSigned(value) {
        this._isSigned.set(value);
    }
    destroy() {
        this.eventsChannel.destroy();
    }
    setSigned() {
        if (this.isSigned) {
            return;
        }
        this.signDate = new Date();
        this._isSigned.set(true);
    }
    setUnsigned() {
        if (!this.isSigned) {
            return;
        }
        this.signDate = null;
        this._isSigned.set(false);
    }
    toJSON() {
        const { userId, isOwner, isSigned, signDate, buddyId } = this;
        return { userId, isOwner, isSigned, signDate, buddyId };
    }
    onSigned({ data: userId }) {
        if (userId !== this.userId || this.isSigned) {
            return;
        }
        this.setSigned();
    }
    onUnsigned({ data: userId }) {
        if (userId !== this.userId || !this.isSigned) {
            return;
        }
        this.setUnsigned();
    }
}
